import * as React from "react";
import { isMobile } from "react-device-detect";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

export default function SearchBar(props) {
  const [value, setValue] = React.useState("");

  React.useEffect(() => {
    if (!props.searchResultCheck) {
      setValue("");
    }
  }, [props.searchResultCheck]);


  return (
    <>
      <Autocomplete
        value={value}
        size="small"
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            setValue({
              title: newValue,
            });

            props.getSearchResult([newValue]);
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setValue({
              title: newValue.inputValue,
            });

            props.getSearchResult([newValue.inputValue]);
          } else {
            setValue(newValue);

            props.getSearchResult([newValue]);
          }
        }}

        filterOptions={createFilterOptions({
          matchFrom: "any",
          ignoreCase: true,
          stringify: (option) => option.addr + option.tel + option.cusName + option.District+option.Tehsil,
        })}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        id="Search"
        options={props.stores}
        forcePopupIcon={true}
        popupIcon={<SearchIcon />}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === "string") {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.addr;
        }}
        renderOption={(props, option) => (
          <li {...props} key={option.key}>
            {option.addr}
          </li>
        )}
        sx={{ width: isMobile ? '100%' : 300 }}
        freeSolo
        renderInput={(params) => (
          <TextField
            {...params}
            inputProps={{
              ...params.inputProps,
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  e.stopPropagation();
                }
              },
            }}
            label="Search by Name, Mobile No."
          />
        )}
      />
    </>
  );
}
